// src/StatsCalculator.js

import React, { useState } from 'react';
import './StatsCalculator.css';

const StatsCalculator = () => {
  const [numbers, setNumbers] = useState('');
  const [operation, setOperation] = useState('mean');
  const [result, setResult] = useState(null);

  const handleNumbersChange = (e) => {
    setNumbers(e.target.value);
  };

  const handleOperationChange = (e) => {
    setOperation(e.target.value);
  };

  const calculateResult = () => {
    const numArray = numbers.split(',').map(Number).filter(n => !isNaN(n));

    let res;
    switch (operation) {
      case 'mean':
        res = numArray.reduce((a, b) => a + b, 0) / numArray.length;
        break;
      case 'median':
        const sortedNums = [...numArray].sort((a, b) => a - b);
        const mid = Math.floor(sortedNums.length / 2);
        res = sortedNums.length % 2 !== 0 ? sortedNums[mid] : (sortedNums[mid - 1] + sortedNums[mid]) / 2;
        break;
      case 'mode':
        const freqMap = {};
        let maxFreq = 0;
        numArray.forEach(num => {
          freqMap[num] = (freqMap[num] || 0) + 1;
          if (freqMap[num] > maxFreq) maxFreq = freqMap[num];
        });
        res = Object.keys(freqMap).filter(num => freqMap[num] === maxFreq).join(', ');
        break;
      case 'stdDev':
        const mean = numArray.reduce((a, b) => a + b, 0) / numArray.length;
        const variance = numArray.reduce((acc, num) => acc + (num - mean) ** 2, 0) / numArray.length;
        res = Math.sqrt(variance);
        break;
      default:
        res = null;
    }
    setResult(res);
  };

  return (
    <div className="stats-calculator">
      <h1>Statistics Calculator</h1>
      <div>
        <label>
          Numbers (comma separated):
          <input type="text" value={numbers} onChange={handleNumbersChange} />
        </label>
      </div>
      <div>
        <label>
          Operation:
          <select value={operation} onChange={handleOperationChange}>
            <option value="mean">Mean</option>
            <option value="median">Median</option>
            <option value="mode">Mode</option>
            <option value="stdDev">Standard Deviation</option>
          </select>
        </label>
      </div>
      <button onClick={calculateResult}>Calculate</button>
      {result !== null && <div className="result">Result: {result}</div>}
    </div>
  );
};

export default StatsCalculator;
